import { render, staticRenderFns } from "./instructionsDetailShop.vue?vue&type=template&id=5807b9a8&scoped=true&"
import script from "./instructionsDetailShop.vue?vue&type=script&lang=js&"
export * from "./instructionsDetailShop.vue?vue&type=script&lang=js&"
import style0 from "./instructionsDetailShop.vue?vue&type=style&index=0&id=5807b9a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5807b9a8",
  null
  
)

export default component.exports